const sampleTC = {};
export default sampleTC;
